<template>
    <div>
        <rkm-data-table
            :disabled-button-search="true"
            :fields="fields"
            :repository="repositories.solicitacao"
            ref="DataTable"
            sort-by="nome"
        >
            <template v-slot:cell(nome)="{item}">
                {{ item.nome }}

                <template v-if="item.nomeSocial">
                    <template v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{item.nomeSocial}})</strong>
                    </template>

                    <template v-else>
                        ({{item.nomeSocial}})
                    </template>
                </template>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="checkRegister(item)"
                    color="primary"
                    small
                    title="Acessar"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalSolicitacao ref="ModalSolicitacao" />
    </div>
</template>

<script>

//components
import ModalSolicitacao from './components/solicitacao-lista/Modal'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Mixins.
import {repository, error, certificadoDigital} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {ModalSolicitacao},
    created() {
        this.repositories = {
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
        }

        this.load()
    },
    data: () => ({
        enums: {
            preferenciaNome,
        },
        fields: [
            {key: 'nome', label: 'Nome (Nome social)', name: 'cidadao.nome', searchable: true, sortable: true},
            {key: 'nomeSocial', label: 'Nome social', name: 'cidadao.nomeSocial', searchable: true, sortable: true, visible: false},
            {key: 'dataNascimento', label: 'Data de nascimento', name: 'cidadao.dataNascimento', searchable: true, sortable: true},
            {key: 'nomeMae', label: 'Nome da mãe', name: 'cidadao.nomeMae', searchable: true, sortable: true},
            {key: 'prontuario', label: 'Prontuário municipal', name: 'paciente.prontuario', searchable: true, sortable: true},
            {key: 'cpf', label: 'CPF', name: 'cidadao.cpf', searchable: true, sortable: true},
            {key: 'cns', label: 'CNS', name: 'cidadao.cns', searchable: true, sortable: true},
            {key: 'totalSolicitacoesPendentes', label: 'Total de solicitações pendentes', name: 'totalSolicitacoesPendentes', sortable: true},
            {key: 'actions', label: 'Ações', name: 'actions', class: 'col-min'},
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.solicitacao.getListData()
                .then(({ data }) => {
                    this.exibirAvisoValidadeCertificadoDigital(data.additionals.dadosCertificadoDigital)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async checkRegister(item) {

            if (item.diasCadastroDesatualizado > 0) {

                let msg = `O cadastro do paciente está desatualizado há <strong>${item.diasCadastroDesatualizado} dia(s)</strong>. Deseja continuar?`

                if (item.enderecoDesatualizadoBloqueado) {

                    msg = `O cadastro do paciente está desatualizado há <strong>${item.diasCadastroDesatualizado} dia(s)</strong>.
                        Endereço do usuário também deve ser atualizado. Deseja continuar?`
                }

                this.showConfirmation(
                    msg,
                    async () => {
                        this.$nextTick().then(() => this.abrirSolicitacao(item))
                    },
                );
            } else {

                this.abrirSolicitacao(item)
            }
        },
        abrirSolicitacao(item) {

            if (item.enderecoDesatualizadoBloqueado) {

                this.showAlert(
                    'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                    'Atenção'
                )

                return
            }

            if (this.isModal) {
                this.$emit('create', item.id)
            } else {
                this.openModal(item)
            }
        },
        openModal(paciente) {

            this.$refs.ModalSolicitacao.open(paciente)
        },
    },
    mixins: [repository, error, certificadoDigital],
    props: {
        isModal: { type: Boolean },
    },
}
</script>